export const signup = {
    "signup": "Regístrate",
    "signin": "Iniciar sesión",
    "username": "Nombre de usuario",
    "password": "Contraseña",
    "first_name": "Nombre",
    "last_name": "Apellido",
    "already_have_an_account": "¿Ya tienes una cuenta?",
    "or_with": "o",
    "open_a_new_user": "Abrir una nueva cuenta",
    "open_a_new_user_sub_title": "Abrir una nueva cuenta te permitirá abrir edificios adicionales con la misma cuenta",
    "open_a_new_user_with": "Abrir cuenta con",
    "email_verify": "Verificar correo electrónico",
    "password_verify": "Verificar contraseña",
    "test": "probar",
    "email": "Correo electrónico",
    "phone": "Teléfono"
};
